<template>
  <div>
    <SimpleHeader></SimpleHeader>
    <div class="login-box">
      <h3 class="title">{{ title }}</h3>
      <!-- <div class="tip">{{ $t(100) }}</div> -->
      <el-form
        ref="form"
        :rules="rules"
        :model="form">
        <div v-if="configObj.isOpenGlobalVerifyCode==='1'&&configObj.isOpenBindVerifyCode==='1'">
          <div class="item" v-if="!userInfo.mobile">
            <div class="label mb5">{{ $t(101) }}</div>
            <el-form-item>
              <el-input v-model="userInfo.email" disabled>
              </el-input>
            </el-form-item>
          </div>
          <div class="item" v-else>
            <div class="label mb5">{{ $t(102) }}</div>
            <el-form-item>
                <el-input v-model="userInfo.mobile" disabled>
                <el-select slot="prepend" v-model="userInfo.areaCode" class="code-select" filterable popper-class="bfff" disabled>
                  <el-option
                    v-for="item in countryList"
                    :key="item.countryCode"
                    :label="'+'+item.areaCode"
                    filterable
                    :value="item.areaCode"
                  ></el-option>
                </el-select>
              </el-input>
            </el-form-item>
          </div>
        </div>
        <div class="item" v-if="configObj.isOpenGlobalVerifyCode==='1'&&configObj.isOpenBindVerifyCode==='1'">
          <div class="label mb5">{{ $t(122) }}</div>
          <el-form-item
            prop="code">
              <el-input v-model="form.code">
                <el-button slot="append" :disabled="text!==sendText" type="text" @click="sendCode">
                  <span :class="{'countDown': sendText !== text}">{{ sendText }}</span>
                </el-button>
            </el-input>
          </el-form-item>
        </div>
        <div>
          <div class="item" v-if="$route.name!=='UpdateMobile'">
            <div class="label mb5">{{ accountTitle }}</div>
            <el-form-item prop="email">
              <el-input v-model="form.email">
              </el-input>
            </el-form-item>
          </div>
          <div class="item" v-else>
            <div class="label mb5">{{ accountTitle }}</div>
            <el-form-item prop="mobile">
                <el-input v-model="form.mobile">
                <el-select slot="prepend" v-model="form.areaCode" class="code-select" filterable popper-class="bfff">
                  <el-option
                  v-for="item in countryList"
                  :key="item.countryCode"
                  :label="'+'+item.areaCode"
                  filterable
                  :value="item.areaCode"
                >{{ item.englishName+'+'+item.areaCode }}</el-option>
                </el-select>
              </el-input>
            </el-form-item>
          </div>
          <div class="item" v-if="configObj.isOpenGlobalVerifyCode==='1'&&configObj.isOpenBindVerifyCode==='1'">
            <div class="label mb5">{{ $t(122) }}</div>
            <el-form-item
              prop="updateCode">
                <el-input v-model="form.updateCode">
                  <el-button slot="append" :disabled="text1!==sendText1" type="text" @click="sendCode1">
                    <span :class="{'countDown': sendText1 !== text1}">{{ sendText1 }}</span>
                  </el-button>
              </el-input>
            </el-form-item>
          </div>
        </div>
        <div class="pt20 pb10"><el-button type="primary" @click="doSubmit" :loading="loading">{{ $t(127) }}</el-button></div>
        <el-button type="text" @click="$router.go(-1)" class="el-icon-back fs16"></el-button>
        <!-- <el-button type="text" @click="$router.push('/register')">{{ $t(104) }}</el-button> -->
      </el-form>
      <div class="corpyrights">© 2017 - 2026 {{ configObj.appName }} All rights reserved</div>
    </div>
  </div>
</template>

<script>
import loginMixins from '@/mixins/login.js'
import SimpleHeader from '@/components/SimpleHeader'
import { bindEmail, bindMobile, getCodeByToken, getEmailCodeWithoutToken, getMobileCodeWithoutToken } from '@/api'
import utils from '@/utils/misc'
export default {
  name: 'UpdateMobileEmail',
  components: { SimpleHeader },
  mixins: [loginMixins],
  data() {
    return {
      form: {
        code: '',
        email: '',
        mobile: '',
        areaCode: window.configObj.defaultAreaCode,
        updateCode: ''
      },
      sendText: '',
      text: this.$t('123'),
      timer: null,
      sendText1: '',
      text1: this.$t('123'),
      timer1: null
    }
  },
  computed: {
    configObj() {
      return window.configObj
    },
    rules() {
      return {
        ...this.commonRules
      }
    },
    countryList() {
      return this.$store.state.countryList
    },
    userInfo() {
      return {
        ...this.$store.state.userInfo,
        mobile: this.$store.state.userInfo.mobile ? this.$store.state.userInfo.mobile.replace(/(\d){1}\d+(\d{3})/, '$1****$2') : '',
        email: this.$store.state.userInfo.email ? this.$store.state.userInfo.email.replace(/(\d){1}\d+(\d{3})/, '$1****$2') : '',
      }
    },
    title() {
      if (this.$route.name === 'UpdateMobile') {
        return this.$route.query.type === '1' ? this.$t(157) : this.$t(159)
      } else {
        return this.$route.query.type === '1' ? this.$t(158) : this.$t(160)
      }
    },
    accountTitle() {
      if (this.$route.name === 'UpdateMobile') {
        return this.$route.query.type === '1' ? this.$t(102) : this.$t(155)
      } else {
        return this.$route.query.type === '1' ? this.$t(101) : this.$t(156)
      }
    }
  },
  beforeMount() {
    if (this.countryList.length === 0) {
      this.$store.dispatch('getCountries')
    }
    this.sendText = utils.getLs('sendText') || this.text
    this.setTimer()
    this.sendText1 = utils.getLs('sendText1') || this.text1
    this.setTimer1()
  },
  methods: {
    setTimer() {
      clearInterval(this.timer)
      this.timer = setInterval(() => {
        if (isNaN(this.sendText)) return
        if (this.sendText <= 1) {
          this.sendText = this.text
          clearInterval(this.timer)
          utils.removeLs('sendText')
        } else {
          this.sendText--
          utils.setLs('sendText', this.sendText)
        }
      }, 1000)
    },
    setTimer1() {
      clearInterval(this.timer1)
      this.timer1 = setInterval(() => {
        if (isNaN(this.sendText1)) return
        if (this.sendText1 <= 1) {
          this.sendText1 = this.text1
          clearInterval(this.timer)
          utils.removeLs('sendText')
        } else {
          this.sendText1--
          utils.setLs('sendText', this.sendText1)
        }
      }, 1000)
    },
    sendCode() {
      if (this.loading) return
      const obj = {
        scene: this.$route.name === 'UpdateMobile' ? 'SET_MOBILE' : 'SET_EMAIL',
        type: this.userInfo.mobile ? 'MOBILE' : 'EMAIL'
      }
      this.loading = true
      getCodeByToken(obj).then(() => {
        this.sendText = 60
        this.setTimer()
      }).finally(() => {
        this.loading = false
      })
    },
    sendCode1() {
      if (this.loading) return
      const key = this.$route.name === 'UpdateMobile' ? 'mobile':'email'
      this.$refs.form.validateField(key, (error) => {
        if (!error) {
          const obj = {
            scene: this.$route.name === 'UpdateMobile' ? 'SET_MOBILE' : 'SET_EMAIL',
            [key]: this.form[key]
          }
          if (this.$route.name === 'UpdateMobile') {
            obj.areaCode = this.form.areaCode
          }
          this.loading = true
          const api = this.$route.name !== 'UpdateMobile' ? getEmailCodeWithoutToken: getMobileCodeWithoutToken
          api(obj).then(() => {
            this.sendText1 = 60
            this.setTimer1()
          }).finally(() => {
            this.loading = false
          })
        }
      })
    },
    doSubmit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.loading = true
          const obj = {...this.form}
          const api = this.$route.name === 'UpdateMobile'? bindMobile: bindEmail
          if (!obj.code) {
            obj.code = '123456'
          }
          const key = this.$route.name === 'UpdateMobile'? 'mobileCode' : 'mailCode'
          obj[key] = obj.updateCode || '123456'
          delete obj.updateCode
          if (this.$route.name === 'UpdateMobile') {
            obj.areaCode = this.form.areaCode
            delete obj.email
          } else {
            delete obj.mobile
            delete obj.areaCode
          }
          api(obj).then(res => {
            this.$router.go(-1)
            this.$store.dispatch('getUserInfo')
          }).finally(() => {
            this.loading = false
          })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .login-box{
    color: #1E2329;
    width: 400px;
    margin: 10vh auto;
    .title{
      font-size: 32px;
      font-weight: 600;
      margin-bottom: 60px;
    }
    .tab{
      margin: 40px 0px 20px 0px;
      color: #707A8A;
      font-size: 16px;
      .item{
        display: inline-block;
        cursor: pointer;
        padding: 8px 24px;
        margin-right: 12px;
        &.active{
          background-color: #F5F5F5;
          color: #1E2329;
          border-radius: 8px;
        }
      }
    }
    .el-input__inner{
      height: 46px;
      line-height: 46px;
    }
  }
  .corpyrights{
    position: fixed;
    bottom: 10px;
    text-align: center;
    font-size: 12px;
    width: 100%;
    left: 0;
  }
</style>
